let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lTiX1")).then(() => parcelRequire('3LIgV'));